import { Component } from "react";
// import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

class UserList extends Component {
    state = {
        redirectToHome: false,
    };

    handleBackgroundClick = () => {
        this.props.toggleMenu();
    };

    stopPropagation = (e) => {
        e.stopPropagation();
    };
//     handleUserSwap = (id) => {
//     const user = this.state.AllUserInfo.find(item => item.uniqueID === id);
//     if (user) {
//         this.setState({ userInfo: user });
//     }
// }

    render() {
        const { isMenuVisible, AllUserInfo, selectedUserId } = this.props;

        const userlist = AllUserInfo.length > 0 ? AllUserInfo.map(list => {
             const isActive = list.uniqueID === selectedUserId; 
            return (
                <li className={isActive ? "active" : ""}  key={list.id} onClick={() => this.props.handleUserSwap(list.uniqueID)}>
                    <div className="line"></div> {list.firstName} {list.lastName}
                </li>
            )
        }) : null


        return (
            <div
                className={`dash_dark_background ${isMenuVisible ? "visible" : "hidden"}`}
                onClick={this.handleBackgroundClick}
            >
                <div
                    className="dash_menu_container"
                    onClick={this.stopPropagation}
                >
                    <nav className="dash_menu_cover">
                        {userlist}
                    </nav>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userInfo: state.user,
});

export default connect(mapStateToProps)(UserList);
